import React, { FunctionComponent } from "react";
import {
  MuiThemeProvider,
  Table,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import { useTableStyles } from "../../useTableStyle";
import { useCashiersStyles } from "../useCashiersStyles";
import { api } from "../../../api";
import { ThemeProvider } from '@mui/system';

interface cashierProps {
  cashiers: any;
  showDetails: (details: any, userData: any) => void;
}
export const CashiersReconcilationList: FunctionComponent<cashierProps> = ({
  cashiers,
  showDetails,
}) => {
  const getMuiTheme = useTableStyles();
  const classes = useCashiersStyles();

  const handleRowClick = async (headId: number) => {
    const filterData = cashiers.find((i: any) => i.recons_head_id === headId);
    const result = await api.get(`cashier-reconciliation/${headId}`);
    showDetails(result, filterData);
  };

  const columns = ["Name", "Code", "Bod Date", "Bill Count", ""];

  const options = {
    selectableRows: undefined,
    selectableRowsHeader: false,
    rowsPerPage: 10,
    rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
    print: false,
    download: false,
    filter: false,
    viewColumns: false,
    display: true,
    responsive: undefined,
    fixedHeaderOptions: {
      xAxis: true,
      yAxis: true,
    },
    isRowSelectable: function () {
      return false;
    },
    customRowRender: (data: any) => {
      return (
        <TableRow
          className={classes.tableRow}
          onClick={() => {
            handleRowClick(data[4]);
          }}
        >
          <TableCell>
            <Typography className={classes.tableCell}>{data[0]}</Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.tableCell}>{data[1]}</Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.tableCell}>{data[2]}</Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.tableCell}>{data[3]}</Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.tableCell}>{""}</Typography>
          </TableCell>
        </TableRow>
      );
    },
  };

  return (
    <Table>
      <ThemeProvider theme={getMuiTheme}>
        <MUIDataTable
          title={"Cashiers List"}
          data={cashiers?.map((cashier: any) => {
            return [
              cashier.full_name,
              cashier.user_code,
              moment(cashier.bod_date).format("DD/MM/YYYY  h:mm:ss A"),
              cashier.bill_count,
              cashier.recons_head_id,
            ];
          })}
          columns={columns}
          options={options}
        />
      </ThemeProvider>
    </Table>
  );
};
